import { toQueryString } from '@ykz/ykz-util/base';
export default {
  name: "shareOrderList",
  props: {
    shareOrderList: Array,
    goodId: {
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},
  methods: {
    goKankanSelectList: function goKankanSelectList() {
      window.location.href = '/front/kankan/selectedOrderList?' + toQueryString({
        goodId: this.goodId,
        fromPage: 'productDetail'
      });
    }
  }
};